<template>
    <div>
        <v-row>
            <v-col cols="4" v-for="({ text, value, formatter }) in totalCards" :key="text">
                <v-card height="127">
                    <v-card-subtitle class="">{{ text }}</v-card-subtitle>
                    <v-divider />
                    <v-card-text>
                        <div v-if="loading" style="height: 100%" class="d-flex justify-center align-center">
                            <v-icon size="30px" class="fa-spin" >
                                fa-spinner
                            </v-icon>                    
                        </div>
                        <div v-else>
                            <div class="display-1 text--primary">{{ formatter(value(totals)) }}</div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-if="team">
            <v-col>
                <v-card>
                    <v-card-text>
                        <loader v-if="loading" />
                        <vue-apex-charts v-else type="line" height="400px" :options="chart.options" :series="chart.series" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <loader v-if="loading" />
                <v-card v-else>
                    <v-card-text>
                        <v-subheader>
                            <v-row>
                                <v-col v-for="header in headers" :key="header.text" @click="setSort(header.field)">
                                    {{ header.text }}
                                    <v-icon v-if="sortField === header.field && sortOrder">fa-angle-down</v-icon>
                                    <v-icon v-else-if="sortField === header.field">fa-angle-up</v-icon>
                                </v-col>
                            </v-row>
                        </v-subheader>
                        <v-divider />
                        <v-virtual-scroll height="70vh" item-height="64" :items="sortedAgents" bench="1000" class="striped-scroll">
                            <template v-slot:default="{ item: agent }">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-row align="baseline">
                                            <v-col v-for="header in headers" :key="header.text">
                                                <span>{{ header.formatter(agent[header.field]) }}</span>
                                            </v-col>
                                        </v-row>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-virtual-scroll>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
	components: {
		VueApexCharts
	},
    data () {
        return {
            loading: true,
            agents: null,
            chart: {
                options: {
                    colors: ['#000000', '#FFEB3B', '#F44336', '#4CAF50'],
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    title: {
                        text: 'Indbakker'
                    },
                    stroke: {
                        show: true,
                        width: [0, 0, 0, 2]
                    },
                    animations: {
                        enabled: false
                    },
                    yaxis: {
                        labels: {
                            formatter: this.$options.filters.separator
                        },
                        max: max => (max || (1 / 1.1)) * 1.1
                    },
                    xaxis: {
                        categories: [],
                        labels: {
                            hideOverlappingLabels: false,
                            rotate: -45,
                            rotateAlways: true
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        enabledOnSeries: [0],
                        formatter: this.$options.filters.separator,
                        offsetY: -20,
                        style: {
                            colors: ['#000']
                        }
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                position: 'top'
                            }
                        }
                    }
                },
                series: []
            },
            sortField: 'inboxes',
            sortOrder: true,
            totalCards: [
                {
                    text: 'Gule indbakker',
                    value: (stats) => stats.yellowInboxes,
                    formatter: this.$options.filters.separator
                },
                {
                    text: 'Røde indbakker',
                    value: (stats) => stats.redInboxes,
                    formatter: this.$options.filters.separator
                },
                {
                    text: 'Total indbakker',
                    value: (stats) => stats.inboxes,
                    formatter: this.$options.filters.separator
                }
            ]
        }
    },
    computed: {
        headers () {
            if (this.department === 'tryg') {
                return [
                    {
                        text: 'Navn',
                        field: 'name',
                        formatter: v => v
                    },
                    {
                        text: 'Gule indbakker',
                        field: 'yellowInboxes',
                        formatter: this.$options.filters.separator
                    },
                    {
                        text: 'Røde indbakker',
                        field: 'redInboxes',
                        formatter: this.$options.filters.separator
                    },
                    {
                        text: 'Total indbakker',
                        field: 'inboxes',
                        formatter: this.$options.filters.separator
                    },
                    {
                        text: 'Uger ikke på mål',
                        field: 'underTargetPercentage',
                        formatter: this.$options.filters.percentage
                    }
                ]
            } else if (this.department === 'alka') {
                return [
                    {
                        text: 'Navn',
                        field: 'name',
                        formatter: v => v
                    },
                    {
                        text: 'Gule indbakker',
                        field: 'yellowInboxes',
                        formatter: this.$options.filters.separator
                    },
                    {
                        text: 'Røde indbakker',
                        field: 'redInboxes',
                        formatter: this.$options.filters.separator
                    },
                    {
                        text: 'Total indbakker',
                        field: 'inboxes',
                        formatter: this.$options.filters.separator
                    }
                ]
            } else return []
        },
        filteredAgents () {
            if (!this.agents) return []
            return this.agents.filter(agent => {
                return agent.name.toLowerCase().includes(this.$store.state.quality.searchString.toLowerCase())
            })
        },
        sortedAgents () {
            const order = this.sortOrder ? -1 : 1
            return [...this.filteredAgents].sort((a, b) => a[this.sortField] > b[this.sortField] ? order : -order)
        },
        department () {
            return this.$store.getters['quality/department']
        },
        year () {
            return this.$store.state.quality.year
        },
        startWeek () {
            return this.$store.state.quality.startWeek
        },
        endWeek () {
            return this.$store.state.quality.endWeek
        },
        ytd () {
            return this.$store.state.quality.ytd
        },
        inactive () {
            return this.$store.state.quality.inactive
        },
        team () {
            return this.$store.state.quality.team
        },
        totals () {
            return this.$reduceNested(this.agents, ['inboxes', 'yellowInboxes', 'redInboxes'])
        },
        searchString () {
            return this.$store.state.quality.searchString
        }
    },
    methods: {
		setSort(field) {
			if (this.sortField === field) this.sortOrder = !this.sortOrder;
			else {
                this.sortField = field
                this.sortOrder = true
            }
		},
        setChartOptions () {
            this.chart.options.dataLabels.enabled = this.agents.length < 30
        },
        async getData () {
            this.loading = true
            const response = await this.$http().get('quality/status/inboxes', {
                params: {
                    year: this.$store.state.quality.year,
                    startWeek: this.$store.state.quality.startWeek,
                    endWeek: this.$store.state.quality.endWeek,
                    team: this.team,
                    department: this.department,
                    inactive: this.$store.state.quality.inactive
                }
            })
            this.agents = response.data.agents
            this.chart.options.xaxis.categories = response.data.labels
            this.chart.series = response.data.series
            this.setChartOptions()
            this.loading = false
        }
    },
    watch: {
        selectedAgent: function () {
            this.getComplaints(this.selectedAgent)
        },
        department: function () {
            this.getData()
        },
        year: function () {
            this.getData()
        },
        startWeek: function () {
            this.getData()
        },
        endWeek: function () {
            this.getData()
        },
        ytd: function () {
            this.getData()
        },
        inactive () {
            this.getData()
        },
        team: function () {
            this.getData()
        }
    },
    created () {
        this.$store.state.quality.searchString = ''
        this.getData()
    }
}
</script>